import axios from 'axios';

import {API_URL} from './constants';

const validateToken = (token: string) => axios.post(`${API_URL}/password/validate-token`, {token});

const forgotPassword = (data: {email: string, captchaToken: string}) => axios.post(`${API_URL}/password/forgot`, data);

const resetPassword = (token: string, password: string, confirmPassword: string) =>
    axios.post(`${API_URL}/password/reset`, {token, password, confirmPassword});

export const passwordApi = {
    validateToken,
    forgotPassword,
    resetPassword
};